import React from 'react';
import PropTypes from 'prop-types';
import ProductIconContainer from 'apex-web/lib/components/common/ProductIcon/ProductIconContainer';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import WhiteListAddressForm from '../WhiteListAddressForm/WhiteListAddressFormContainer';
import WhiteListedAddressesList from 'apex-web/lib/components/WhiteListedAddressesList/WhiteListedAddressesListContainer';

const sendReceiveClasses = getBEMClasses('send-receive');
const bemClasses = getBEMClasses('send-receive-header');

class WhiteListAddressSidePane extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.onSidePaneOpen({
      customClass: this.props.showDetails
        ? 'retail-sidepane-with-details'
        : 'retail-sidepane',
      hideHeader: true
    });

    this.props.fetchAccountWithdrawInfos();
  }

  render() {
    const {
      ProductSymbol,
      ProductFullName,
      iconFileName,
      ProductId,
      hasExistingAddresses
    } = this.props;

    return (
      <div className={sendReceiveClasses()}>
        <section className={sendReceiveClasses('main')}>
          <header className={bemClasses()}>
            <ProductIconContainer
              iconFileName={iconFileName}
              customClass={bemClasses('logo')}
            />
            <div className={bemClasses('title')}>
              {ProductSymbol} {ProductFullName} {this.context.t('Whitelist')}
            </div>
          </header>
          <section
            className={sendReceiveClasses('main-form', ['white-list-address'])}>
            <WhiteListAddressForm
              ProductSymbol={ProductSymbol}
              ProductFullName={ProductFullName}
              ProductId={ProductId}
            />
          </section>
          {hasExistingAddresses && (
            <section
              className={sendReceiveClasses('main-form', [
                'white-list-address'
              ])}
              style={{ marginTop: '4rem' }}>
              <WhiteListedAddressesList />
            </section>
          )}
        </section>
      </div>
    );
  }
}

WhiteListAddressSidePane.defaultProps = {};

WhiteListAddressSidePane.propTypes = {};

WhiteListAddressSidePane.contextTypes = {
  t: PropTypes.func.isRequired
};

export default WhiteListAddressSidePane;
